import { render, staticRenderFns } from "./ZendeskPublishModal.vue?vue&type=template&id=0a1717a9&"
import script from "./ZendeskPublishModal.vue?vue&type=script&lang=js&"
export * from "./ZendeskPublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/ZendeskPublishModal.vue
// module id = 1075
// module chunks = 0